import { useCallback, useEffect, useId, useSyncExternalStore } from 'react';
const owners = new Map<string, string>();
const listeners = new Set<() => void>();
const emit = () => listeners.forEach(listener => listener());
export function _resetDirtyGuardForTests(): void { owners.clear(); emit(); }
export function isDirty(): boolean { return owners.size > 0; }
export function discardDirtyForms(): void { owners.clear(); emit(); }
export function setDirty(next: boolean, message = 'You have unsaved changes.'): void {
  if (next) owners.set('legacy', message); else owners.delete('legacy'); emit();
}
export function useDirtyStatus(): boolean {
  return useSyncExternalStore(listener => { listeners.add(listener); return () => { listeners.delete(listener); }; }, isDirty, () => false);
}
export function useDirtyForm(message = 'You have unsaved changes.'): { markDirty: () => void; markClean: () => void } {
  const id = useId();
  const markDirty = useCallback(() => { owners.set(id, message); emit(); }, [id, message]);
  const markClean = useCallback(() => { owners.delete(id); emit(); }, [id]);
  useEffect(() => markClean, [markClean]);
  return { markDirty, markClean };
}
/** Legacy explicit guard; routed navigation is additionally covered by useBlocker. */
export function useDirtyGuard(confirmFn: (message: string) => boolean = message => window.confirm(message)): (action: () => void) => void {
  return useCallback(action => { if (isDirty() && !confirmFn('You have unsaved changes. Discard and continue?')) return; discardDirtyForms(); action(); }, [confirmFn]);
}
